var swiper = {};

// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded
async.push(["ready", function() {
    // call owl carousel inits
    initializeCarousels();
}]);

$(window).resize(function() {
    // initRelatedCarousel();
});

// function to group all carousel inits
window.initializeCarousels = function initializeCarousels(){

    initRelatedCarousel();

    if ($('.fl-swiper').length) {
        $('.fl-swiper').each(function(){
            let swiperId = $(this).data('ref');
            swiper[swiperId] = undefined;
            const element = this;
            initFinanceLandingCarousel(element, swiperId);

            window.addEventListener('resize', function(event) {
                initFinanceLandingCarousel(element, swiperId);
            }, true);
        });
    }

    if ($('#listings-slider-swiper').length) {

        const sliderWidth = $('#listings-slider-swiper').outerWidth();
        let nextAmount = 4;
        if (sliderWidth > 2600) {
            nextAmount = 6;
        } else if (sliderWidth > 2600) {
            nextAmount = 8;
        }

        const swiper = new Swiper('#listings-slider-swiper', {
            // Optional parameters
            loop: true,
            slidesPerView: 1,
            spaceBetween: 0,
            lazy: {
                threshold: 50,
                loadPrevNext: true,
                loadPrevNextAmount: nextAmount,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            centeredSlides: false,
            watchSlidesVisibility: true,
            initialSlide: 0,
            preloadImages: false,
            breakpoints: {
                992: {
                    slidesPerView: "auto",
                    spaceBetween: 4,
                },
            },
            on: {
                init: function (e) {
                    let slideNum = parseInt(e.realIndex + 1);
                    $('#listing-details .imglist-wrap span').html(slideNum);
                },
                slideChange: function(e) {
                    let slideNum = parseInt(e.realIndex + 1);
                    $('#listing-details .imglist-wrap span').html(slideNum);
                },
                touchEnd: function(e) {
                    trackSwiperSwipe(e);
                    trackListingPhotoNavigation(e);
                },
            },
        });
    }

    if ($('.fullwidth-slider').length) {
        var fullwidthSlider = new Swiper(".fullwidth-slider", {
            autoplay: {
                delay: 6000,
            },
            spaceBetween: 0,
            items:1,
            lazy: {
                threshold: 50,
                loadPrevNext: true,
                loadPrevNextAmount: 1,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            // pagination: {
            //     el: ".swiper-pagination",
            //     clickable: true,
            // },
        });
    }

    if ($('.landingSlider').length) {
        var landingSlider = new Swiper(".landingSlider", {
            spaceBetween: 0,
            items:1,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
    }

    if ($('.branchSlider').length) {
        var branchSwiper = new Swiper(".branchSlider", {
            spaceBetween: 0,
            items:1,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
    }

    if ($('.featureVehicles').length) {
        var featureVehicles = new Swiper(".featureVehicles", {
            spaceBetween: 12,
            items:1,
            loop:true,
            autoplay: {
                delay: 7000,
                disableOnInteraction: false,
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                768: {
                slidesPerView: 2,
                },
                992: {
                slidesPerView: 3,
                },
            },
        });
    }

    // if ($('.homeFeatureSlider').length) {
    //     document.querySelectorAll('.homeFeatureSlider').forEach(item => {
    //         new Swiper("#"+ $(item).attr('id'), {
    //             slidesPerView: 1,
    //             spaceBetween: 24,
    //             simulateTouch: true,
    //             autoplay: false,
    //             delay: 50000,
    //             allowTouchMove: true,
    //             loop: false,
    //             pagination: {
    //                 el: ".swiper-pagination",
    //                 dynamicBullets: true,
    //                 dynamicMainBullets: 3,
    //                 clickable: true,
    //             },
    //             breakpoints: {
    //                 640: {
    //                     slidesPerView: 2,
    //                 },
    //                 992: {
    //                     slidesPerView: 3,
    //                 },
    //                 1440: {
    //                     slidesPerView: 4,
    //                     simulateTouch: false,
    //                     allowTouchMove: false,
    //                     loop: false,
    //                 }
    //             },
    //         });
    //     });
    // }

    if ($('.panelTextCarousel').length) {
        new Swiper(".panelTextCarousel", {
            spaceBetween: 30,
            items:1,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {

                768: {
                    slidesPerView: 1,
                },
                1200: {
                    slidesPerView: 2,
                }
            },
        });
    }

}

function initRelatedCarousel() {

     if ($('.relatedVehicles').length) {
        var relatedVehicles = new Swiper(".relatedVehicles", {
            spaceBetween: 24,
            items:1,
            loop:true,
            autoplay: {
                delay: 7000000,
                disableOnInteraction: false,
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                768: {
                slidesPerView: 2,
                },
                992: {
                slidesPerView: 3,
                },
                1200: {
                slidesPerView: 3,
                },
                // 1440: {
                // slidesPerView: 5,
                // },
            },
            on: {
                slideChange: function () {
                    initWeeklyPrices();
                },
                init: function () {
                    initWeeklyPrices();
                },
            }
        });
    }

}

/* function trackOwlCarouselSwipe(event){
    // console.log(event);
    var id = event.currentTarget.id;
    if(typeof dataLayer !== 'undefined'){
    // console.log(id);
        dataLayer.push({'event': 'owl-swipe', 'id': id});
    }
}
 */
function trackSwiperSwipe(event){
    var id = event.el.id;
    if(typeof dataLayer !== 'undefined'){
        dataLayer.push({'event': 'owl-swipe', 'id': id});
        if (typeof ga !== 'undefined') {
            // ga('send', 'event', 'category', 'action', 'label');
            ga('send', 'event', 'Listing Image Swipe', 'Listing Image Swipe', stocknumber);
        }
    }
}


function trackListingPhotoNavigation(event) {

    // track fb pixel code and google analytics events on first click only
    if (!dragged) {

        // console.log(stocknumber);

        // FB Pixel Code
        if (typeof fbq !== 'undefined') {
            fbq('trackCustom', 'Clicked / Swiped Listing Photo', {
                stock_number: stocknumber
            });
        }
        // GA Event
        if (typeof ga !== 'undefined') {
            ga('send', 'event', 'Listing Photo', 'Click', stocknumber);
        }

        // flag user had already dragged once
        dragged = true;

    }
}

function initFinanceLandingCarousel(el, id) {

    if (window.innerWidth < 992 && swiper[id] == undefined) {
        swiper[id] = new Swiper(el, {
            // Optional parameters
            loop: true,
            slidesPerView: 1,
            spaceBetween: 0,
            lazy: {
                threshold: 50,
                loadPrevNext: true,
                loadPrevNextAmount: 1,
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            centeredSlides: true,
            watchSlidesVisibility: true,
            initialSlide: 0,
            preloadImages: false,
        });
    } else if (window.innerWidth >= 992 && swiper[id] != undefined) {
        swiper[id].destroy();
        swiper[id] = undefined;

        $(el).find('.swiper-wrapper').removeAttr('style');
        $(el).find('.swiper-slide').removeAttr('style');
    }
}